<template>
  <div class="product align-center w-100 pb10">
    <div class="block no-underline product-link" @click="clickToClose">
      <router-link :to="productLink" class="no-underline" data-testid="productLink">
        <div class="product-image relative"
             :class="[{ sale: labelsActive && isOnSale }, { new: labelsActive && isNew }]"
        >
          <product-image class="product-image__content"
                         :image="thumbnailObj"
                         :alt="product.name | htmlDecode"
                         :heigh="imageHeight"
                         :width="imageWidth"
                         data-testid="productImage"
                         :index="idx"
                         :slidesPerView="slidesPerView"
                         :categoryIndex="categoryIndex"
          />
        </div>
      </router-link>
      <div class="row">
        <div class="additinal-wrap col-xs-12">
          <div class="buttons-wrap row my10 center-xs start-lg" v-if="isCheckoutAllowed && activeButtonAddToCart">
            <div class="col-xs-12 col-lg-12" v-if="needToDisplayConfigurator">
              <div @click="showOptionsModal"
                   class="no-outline list-button p10 bg-cl-white ripple cl-korzyna-green medium center-xs pointer">
                <img src="/assets/icons/icon-range.svg" class="mr10" alt="Options" width="20" height="18" loading="lazy" fetchpriority="auto"><span>{{ $t('Add to cart') }}</span>
              </div>
            </div>
            <div class="col-xs-12" v-else>
              <add-to-cart
                :product="singleOptionProduct ? singleOptionProduct : product"
                class="list-button h5 py10 center-xs"
              />
            </div>
          </div>
          <div class="name-wrap row">
            <div class="col-xs-12 prices bold top-xs" v-if="!onlyImage">
              <price :product="product" :qty="1" />
            </div>
            <div class="col-xs-12 name pt10 start-xs">
              <router-link
                :to="productLink"
                data-testid="productLink"
                class="no-underline"
              >
                <p class="cl-mine-shaft w-100 product-name medium m0 fs16" v-if="!onlyImage">
                  {{ product.name | htmlDecode }}
                </p>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="short-desc" v-if="product.short_description">
      <div class="col-xs-12 align-left descriptions light" id="descriptions" ref="descriptions" :class="{ 'short-description': flagDescriptions }" v-html="product.short_description" />
      <div class="toogle-desc pointer" @click="isActiveDesc = !isActiveDesc; flagDescriptions = !flagDescriptions">
        <p v-if="isActiveDesc && !flagDescriptions" class="flex middle-xs light h5">
          <span class="material-icons">keyboard_arrow_up</span> Згорнути опис
        </p>
      </div>
      <div class="toogle-desc pointer" @click="isActiveDesc = !isActiveDesc; flagDescriptions = !flagDescriptions">
        <p v-if="!isActiveDesc && flagDescriptions" class="flex middle-xs light h5">
          <span class="material-icons">keyboard_arrow_down</span>Розгорнути опис
        </p>
      </div>
    </div>
    <configurator v-if="needToDisplayConfigurator" :product="product" :categoryId="categoryId" />
    <div class="weight pt10 start-xs" v-if="product.weight">
      <span>{{ product.weight | toWeight }}</span>
    </div>
  </div>
</template>

<script async>
import { CATALOG_UPD_CUSTOM_OPTION } from '@vue-storefront/core/modules/catalog/store/product/mutation-types';
import config from 'config'
import { ProductTile } from '@vue-storefront/core/modules/catalog/components/ProductTile.ts'
import { mapMutations, mapGetters } from 'vuex'

const AddToCart = () => import(/* webpackChunkName: "vsf-add-to-cart" */ 'theme/components/core/AddToCart');
const Price = () => import(/* webpackChunkName: "vsf-price" */ 'theme/components/core/blocks/Product/Price.vue');
const Configurator = () => import(/* webpackChunkName: "vsf-configurator" */ 'theme/components/theme/blocks/Home/ProductTileGrid/Configurator');
const ProductImage = () => import(/* webpackChunkName: "vsf-product-image" */ 'theme/components/core/ProductImage');

function _fieldName (co) {
  return 'customOption_' + co.option_id
}

export default {
  name: 'ProductTileGrid',
  data () {
    return {
      isActiveDesc: false,
      flagDescriptions: false,
      singleOptionProduct: null
    }
  },
  mixins: [ProductTile],
  components: {
    ProductImage,
    AddToCart,
    Configurator,
    Price
  },
  props: {
    labelsActive: {
      type: Boolean,
      default: true
    },
    onlyImage: {
      type: Boolean,
      default: false
    },
    idx: {
      type: Number,
      default: 0
    },
    slidesPerView: {
      type: Number,
      default: 6
    },
    categoryIndex: {
      type: Number,
      default: 0
    }
  },
  computed: {
    needToDisplayConfigurator () {
      if (!this.product.custom_options || this.product.custom_options.length === 0 || this.product.custom_options.filter(option => option.is_active === 1).length == 0) {
        return false
      }
      if (this.product.custom_options.length > 1) {
        return true
      }
      return (!this.product.custom_options[0].is_require && this.product.custom_options[0].values && this.product.custom_options[0].values.length > 1)
    },
    activeButtonAddToCart () {
      return this.currentPartner.active && this.currentPartner.enabled
    },
    thumbnailObj () {
      return {
        src: this.thumbnail,
        loading: this.thumbnail
      }
    },
    cartItem () {
      return this.$store.getters['cart/getCartItems'].find(item => item.entity_id === this.product.entity_id)
    },
    qtyInCart () {
      if (this.cartItem) {
        return this.cartItem.qty
      }
    },
    ...mapGetters({
      currentLocation: 'locations/getActiveLocation',
      currentPartner: 'partners/getCurrentPartner'
    }),
    isCheckoutAllowed () {
      return (this.currentLocation.hasOwnProperty('is_checkout_allowed')) ? this.currentLocation.is_checkout_allowed : true
    },
    imageHeight () {
      return config.images.food_thumbnails.height
    },
    imageWidth () {
      return config.images.food_thumbnails.width
    }
  },
  mounted () {
    if (this.$refs.descriptions !== undefined) {
      this.flagDescriptions = this.$refs.descriptions.offsetHeight >= 170;
    }
    if (this.product.custom_options && this.product.custom_options.length === 1 && this.product.custom_options.filter(option => option.is_active === 1).length) {
      this.singleOptionProduct = this.product
      this.setupInputFields()
    }
    this.$bus.$on('product-after-customoptions', this.onAfterCustomOptionsChanged)
  },
  methods: {
    ...mapMutations('product', {
      setCustomOptionValue: CATALOG_UPD_CUSTOM_OPTION
    }),
    setupInputFields () {
      let co = this.product.custom_options[0]
      if (co.values && co.values.length) {
        this.optionChanged(co, co.values[0])
      }
    },
    optionChanged (option, opval) {
      const fieldName = _fieldName(option)
      const value = opval.option_type_id
      this.setCustomOptionValue({ optionId: option.option_id, optionValue: value })
      this.$store.dispatch('product/setCustomOptions', {
        product: this.product,
        customOptions: this.$store.state.product.current_custom_options
      })
      let optionValues = {}
      optionValues[fieldName] = opval
      this.onAfterCustomOptionsChanged({ product: this.product, option: option, optionValues })
    },
    onAfterCustomOptionsChanged (payload) {
      let priceDelta = 0
      let priceDeltaInclTax = 0
      let optionsToProduct = []
      for (const optionValue of Object.values(payload.optionValues)) {
        optionsToProduct.push(optionValue)
        if (typeof optionValue === 'object' && parseInt(optionValue.option_type_id) > 0) {
          if (optionValue.price_type === 'fixed' && optionValue.price !== 0) {
            priceDelta += optionValue.price
            priceDeltaInclTax += optionValue.price
          }
          if (optionValue.price_type === 'percent' && optionValue.price !== 0) {
            priceDelta += ((optionValue.price / 100) * product.price)
            priceDeltaInclTax += ((optionValue.price / 100) * product.priceInclTax)
          }
        }
      }

      if (payload && this.product && payload.product.entity_id === this.product.entity_id) {
        this.singleOptionProduct = Object.assign({}, this.product, { selected_options: optionsToProduct })
        this.singleOptionProduct.price = this.product.price + priceDelta
        this.singleOptionProduct.originalPriceInclTax = this.product.priceInclTax + priceDeltaInclTax
        this.singleOptionProduct.regular_price = this.product.priceInclTax + priceDeltaInclTax
        this.singleOptionProduct.priceInclTax = this.product.priceInclTax + priceDeltaInclTax
      }
    },
    showOptionsModal () {
      this.$bus.$emit('modal-show', `modal-custom-options-${this.product.sku}-${this.categoryId}`);
    },
    onProductPriceUpdate (product) {
      if (product.sku === this.product.sku) {
        Object.assign(this.product, product)
      }
    }
  },
  beforeMount () {
    this.$bus.$on('product-after-priceupdate', this.onProductPriceUpdate)
  },
  beforeDestroy () {
    this.$bus.$off('product-after-priceupdate', this.onProductPriceUpdate)
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/animations/transitions';
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';

$bg-secondary: color(secondary, $colors-background);
$border-secondary: color(secondary, $colors-border);
$color-white: color(white);

.product {
  overflow: hidden;
  box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.08);
  padding: 20px 10px;

  &-image {
    width: 100%;
    height: auto;
    aspect-ratio: 1 / 1;
  }
}
.short-description {
    height: 10.6em;
    overflow: hidden;
    @media (max-width: 990px) {
      height: 11.5em;
    }
    @media (max-width: 500px) {
      height: 10.6em;
    }
    li{
      height: 1.2em;
    }

  }
  .additinal-wrap{
    color: #111;
     .price{
         font-weight: bold;
         color: #111;

                 font-size: 14px;
             vertical-align: top;
        line-height: 16px;
        }
    }
.price-original {
  text-decoration: line-through;
}
.price {
  padding: 0;
}

.weight {
  min-height: 30px;
  box-sizing: border-box;
  font-size: 16px;
  color: #666;
}

.black{
    color: #000;
}
%label {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background-color: $border-secondary;
  text-transform: uppercase;
  color: $color-white;
  font-size: 12px;
}

.product-image{
  width:100%;
  height: 100%;
  max-height: 100%;
  background-color: #fff;
    border-radius: 10px;
  &:hover{
    .product-image__content{
      opacity: 1;
      transform: scale(1.1);
    }
    &.sale::after,
    &.new::after{
      opacity: 1;
    }
  }
  &__content{

    padding-bottom: 100%;
    mix-blend-mode: darken;
    opacity: 1;
    transform: scale(1);
    will-change: transform;
    transition: .3s opacity $motion-main, .3s transform $motion-main;

  }

  &.sale{
    &::after {
      @extend %label;
      content: 'Sale';
    }
  }
  &.new{
    &::after {
      @extend %label;
      content: 'New';
    }
  }
}
  .list-button{
    min-width: 100px;
    border-radius: 10px;
    font-size: 12px;
    border: 1px solid #11bb2e;
    padding-top: 10px;
    padding-bottom: 10px;
    display: flex;
    align-items: center;
    i{
      font-size: 20px;
    }
    img{
      fill: #11bb2e;
    }

    &.disabled {
      border: unset;
    }
  }
</style>
<style lang="scss">
  .descriptions {
    ul {
      list-style: none;
    }
    li::before {
      content: "";
      background-color: #11bb2e;
      display: inline-block;
      font-size: 35px;
      width: 7px;
      height: 7px;
      border-radius: 50%;
      margin-left: -35px;
      margin-right: 10px;
      margin-bottom: 2px;
    }
    li {
      p {
        display: inline;
      }
    }
  }
  .list-button{
    i{
      font-size: 18px;
      margin-right: 0;
    }
  }
</style>
